import React, { useEffect, useState } from 'react'
import Stack from 'react-bootstrap/Stack'

import { getAgentSales } from '../../utilities/api'
import { useReportRefresh } from '../../hooks/useReportRefresh'

import { ReportRefreshButton } from '../ReportRefreshButton'
import LeaderBoard from './Leaderboard'

export default function SalesSummaryWrapper({ organization }) {
  const [data, setData] = useState([])
  const [isLoadingData, setIsLoadingData] = useState(false)
  const { refreshToken, refresh, completeRefresh } =
    useReportRefresh(isLoadingData)

  useEffect(() => {
    if (!organization?.uuid) return

    setIsLoadingData(true)
    getAgentSales(organization.uuid)
      .then((res) => setData(res?.data))
      .catch((err) => console.error(err))
      .finally(() => {
        setIsLoadingData(false)
        completeRefresh()
      })
  }, [organization?.uuid, refreshToken])

  return (
    <>
      <Stack direction="horizontal" gap={3} className="mb-3 align-items-center">
        <h3 className="mb-0">Sales Summary</h3>
        <ReportRefreshButton
          onRefresh={refresh}
          isRefreshing={isLoadingData}
          disabled={isLoadingData || !organization?.uuid}
        />
      </Stack>
      <LeaderBoard data={data} />
    </>
  )
}
